export interface UpdatingOptionsState {
  renewalNumber: string | null;
  headers: {
    token: string | null;
    correlationId: string | null;
  };
  formValues: {
    majorOfferId: string;
    minorsOffers: Record<string, boolean>;
    phoneNumber: string;
    selectedOperator: string;
  };
  saleDeviceId: string | null;
  operators: {
    id: string;
  }[];
  payment: {
    amount: number | null;
    currency: string;
    tax: {
      amount: number;
      label: string;
    } | null;
  };
}

const defaultState: UpdatingOptionsState = {
  renewalNumber: null,
  headers: {
    token: null,
    correlationId: null
  },
  formValues: {
    majorOfferId: '',
    minorsOffers: {},
    phoneNumber: '',
    selectedOperator: ''
  },
  saleDeviceId: null,
  operators: [],
  payment: {
    amount: null,
    currency: '',
    tax: null
  }
};

type AddRenewalNumberAction = {
  type: 'ADD_RENEWAL_NUMBER';
  payload: {
    renewalNumber: string;
  };
};
type AddHeadersAction = {
  type: 'ADD_HEADERS';
  payload: {
    token: string;
    correlationId: string;
  };
};
type SaveFormAction = {
  type: 'SAVE_FORM';
  payload: {
    formValues: {
      majorOfferId: string;
      minorsOffers: Record<string, boolean>;
    };
    saleDeviceId: string | null;
  };
};
type SavePhoneDataAction = {
  type: 'SAVE_PHONE_DATA';
  payload: {
    formValues: {
      phoneNumber: string;
      selectedOperator: string;
    };
    saleDeviceId: string | null;
  };
};
type SavePaymentDataAction = {
  type: 'SAVE_PAYMENT_DATA';
  payload: {
    amount: number;
    label: string;
    currency: string;
  };
};
type AddOperatorsAction = {
  type: 'ADD_OPERATORS';
  payload: {
    operators: {
      id: string;
    }[];
  };
};

type Actions =
  | AddRenewalNumberAction
  | AddHeadersAction
  | SaveFormAction
  | SavePhoneDataAction
  | SavePaymentDataAction
  | AddOperatorsAction;

export default function updatingOptions(state = defaultState, action: Actions) {
  switch (action.type) {
    case ADD_RENEWAL_NUMBER:
      return {
        ...state,
        ...action.payload
      };
    case ADD_HEADERS:
      return {
        ...state,
        headers: action.payload
      };
    case SAVE_FORM:
      return {
        ...state,
        formValues: { ...state.formValues, ...action.payload.formValues },
        saleDeviceId: action.payload.saleDeviceId
      };
    case SAVE_PHONE_DATA:
      return {
        ...state,
        formValues: {
          ...state.formValues,
          ...action.payload.formValues
        }
      };
    case SAVE_PAYMENT_DATA:
      return {
        ...state,
        payment: action.payload
      };
    case ADD_OPERATORS:
      return {
        ...state,
        operators: action.payload.operators
      };
    default:
      return state;
  }
}

export const ADD_RENEWAL_NUMBER = 'ADD_RENEWAL_NUMBER';
export const ADD_HEADERS = 'ADD_HEADERS';
export const SAVE_FORM = 'SAVE_FORM';
export const SAVE_PHONE_DATA = 'SAVE_PHONE_DATA';
export const SAVE_PAYMENT_DATA = 'SAVE_PAYMENT_DATA';
export const ADD_OPERATORS = 'ADD_OPERATORS';
